import React from 'react';
import { useTranslation } from 'react-i18next';
import { ToggleSwitch } from '@brighterion/br-ui';
import clsx from 'clsx';
import styles from './ActivateDeactivateToggle.css';

type Props = Omit<React.ComponentProps<typeof ToggleSwitch>, 'onText' | 'offText'>;

function ActivateDeactivateToggle({ toggleClassName, ...rest }: Props) {
    const { t } = useTranslation();
    const onText = t('Active');
    const offText = t('Inactive');
    const derivedToggleClassName = clsx(styles.activeToggle, toggleClassName);
    return (
        <ToggleSwitch
            className={clsx(styles.container, rest?.className)}
            toggleClassName={derivedToggleClassName}
            onText={onText}
            offText={offText}
            {...rest}
        />
    );
}

export default ActivateDeactivateToggle;
